import { render, staticRenderFns } from "./ScientificDirector.vue?vue&type=template&id=237b1c25&"
import script from "./ScientificDirector.vue?vue&type=script&lang=js&"
export * from "./ScientificDirector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports